module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "form",
    staticClass: "NewsletterForm",
    attrs: {
      "action": "https://www.createsend.com/t/subscribeerror?description=",
      "data-id": "191722FC90141D02184CB1B62AB3DC265C65A3A8F9EC8CC6896119ACFD9BE26FE8001C7E0415F16E05714D135401DD200AFF893F50F2B55E088D85492D91CBED",
      "method": "post"
    }
  }, [(_vm.title) ? _c('p', {
    staticClass: "t-caps-md c-grey-xlt2"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('text-input', {
    staticClass: "NewsletterForm-input",
    attrs: {
      "id": "l260006-260006",
      "name": "cm-ydllld-ydllld",
      "type": "email",
      "placeholder": "Enter your email",
      "large": ""
    },
    on: {
      "submit": _vm.submit
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('noscript', [_c('input', {
    attrs: {
      "type": "submit",
      "value": "Submit"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fabd21c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsletterForm.vue
// module id = 757
// module chunks = 1474